import React from 'react'
import {Head as InertiaHead} from '@inertiajs/react'
import {IAuthState} from "@/Types/auth";

interface Props {
    auth: IAuthState
    title?: string
}

export default function Head({auth, title = ''}: Props) {
    return (
        <InertiaHead title={title && title !== '' ? title : 'Duesy'}/>
    )
}
